import axios from 'axios';
import { API_BASE } from '../config/endpoints';
import { clearToken, getToken } from '../utils/auth';

const request = axios.create({
  baseURL: API_BASE,
  timeout: 10000
});

request.interceptors.request.use(config => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

function isAuthLoginRequest(error) {
  const url = (error.config && error.config.url) || '';
  return /\/auth\/(admin|agent|merchant)\/login\b/.test(url);
}

request.interceptors.response.use(
  response => response,
  error => {
    const status = error.response && error.response.status;
    if (status === 401 && !isAuthLoginRequest(error)) {
      clearToken();
      const path = (window.location.hash || '').replace(/^#\/?/, '/') || '/';
      if (path.split('?')[0] !== '/login') {
        window.location.hash = '#/login';
      }
    }
    return Promise.reject(error);
  }
);

export default request;

